<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <el-form label-width="80px" class="">
      <el-row>
        <el-col :span="6">
          <el-form-item label="表单" prop="">
            <el-input v-model="query.formcode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="表单名称" prop="">
            <el-input v-model="query.formcode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button icon="search" @click="getFormList">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <vggrid :list="list" flexname="" :cols="cols"
      :showfooter="false" :showPage="true" :resizable="true"
      :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
      :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
          <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
          </template>
      </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn.vue"
  import vggrid from '../common/vggrid'
  export default {
    name: 'formIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        cols: [
          { type: 'index', title: '行号',calculExpr:'', width: 80 },
          { field: 'formcode', title: '表单',calculExpr:'', addNewRowFlg: false},
          { field: 'formname', title: '表单名称',calculExpr:'',addNewRowFlg: false},
          { field: 'formtablename', title: '表单数据表',calculExpr:'',addNewRowFlg: false},
        ],
        form: {},
        query: {
          formname: '',
          formcode: '',
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addForm())
      this.$on('CHG', () => this.chgForm())
      this.$on('DEL', () => this.delForm())
      this.$on('CLOSE', () => this.close())
      this.getFormList()
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.form = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addForm () {
        this.$router.push({name: 'addForm', params: {form: this.form}})
      },
      async chgForm () {
        this.$router.push({name: 'addForm', params: {form: this.form}})
      },
      async delForm () {
        console.log(this.form)
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/form/delForm',
            method: "post",
            data: this.form
          })
          if (data.issuccess===1) {
            this.getFormList()
            this.$message.success(data.msg)
          }
        })
      },
      search (target) {},
      async save () {
        await request({
          url: '/xtgl/form/addOrEdit',
          method: "post",
          data: this.form
        })
        this.$message.success('操作成功')
        this.formform = false
        if (!this.form.formid) {
          this.query.currPage = 1
        }
        await this.getFormList()
      },
      async cellClick (row) {
        this.form = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getFormList()
      },
      async getFormList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/form/getFormList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
  }
</script>
<style lang="scss">

</style>
